/**
 * The competitions that get a year tab, newest first. The public list
 * endpoint only returns the current one, so the ids are kept here.
 * countsCorrectAnswers: whether the answer counts only include correct answers. The 2025
 * competition counted every answer, 2026 and onwards count the correct ones.
 * homeId: the consumer competition (home challenge) linked to the competition, when there is one. Its
 * section is shown on the competition's page and hidden when it cannot be loaded, for example when it is not public.
 */
export const COMPETITION_YEARS: { year: number, id: string, countsCorrectAnswers: boolean, homeId?: string }[] = [
  {year: 2026, id: '6abd0d1c30eaed0027dfba1f', countsCorrectAnswers: true, homeId: '6ae91aa222a80b0019808a20'},
  {year: 2025, id: '68ffe296d2cd180027ee79df', countsCorrectAnswers: false}
];
